import * as http from "./http";
import { ApiResponse, ListSort, PaginatedApiResponse } from "../models";
import ApiService from "./service";
import { stringify } from "query-string";
import { Dict } from "../../models";
import { CreateShortlistDto, Project } from "../models/project";
import { Property } from "../models/property";

export class PropertyService extends ApiService {
  public async getPropertyDetails(id: string): Promise<{ project: Property }> {
    const url = `${this.apiDomain}/api/property/${id}`;
    const response = await http.get<ApiResponse<{ project: Property }>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
  public async getPropertyList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Property[]>> {
    const url = `${this.apiDomain}/api/property/list`;
    const response = await http.post<PaginatedApiResponse<Property[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }

  public async getProperyByKey(
    query: string,
    projectIds: string
  ): Promise<Property[]> {
    const url = `${this.apiDomain}/api/property/search-by-projects`;
    const response = await http.post<ApiResponse<Property[]>>(
      url,
      {
        query,
        projectIds,
      },
      this.store
    );
    return response?.data?.data;
  }

  public async searchDeveloper(data: {
    page: number;
    perPage: number;
    query?: string;
    category?: string;
    sortBy?: string;
    sortOrder?: string;
  }): Promise<any[]> {
    const url = `${this.apiDomain}/api/developer/list`;

    const response = await http.post<ApiResponse<any[]>>(url, data, this.store);

    return response?.data?.data;
  }

  public async splitUnits(data: any): Promise<any[]> {
    const url = `${this.apiDomain}/api/property/split-property`;

    const response = await http.post<ApiResponse<any[]>>(url, data, this.store);

    return response?.data?.data;
  }
}
